import Spin from './Spin';

export type { ISpinProps } from './Spin.types';
export default Spin;
